import { render, staticRenderFns } from "./phoneMy.vue?vue&type=template&id=c4bf55f2&scoped=true&"
import script from "./phoneMy.vue?vue&type=script&lang=js&"
export * from "./phoneMy.vue?vue&type=script&lang=js&"
import style0 from "./phoneMy.vue?vue&type=style&index=0&id=c4bf55f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bf55f2",
  null
  
)

export default component.exports